/**
 * @fileoverview gRPC-Web generated client stub for reorgpb
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_type_date_pb = require('../../google/type/date_pb.js')

var proto_utilspb_pagination_pb = require('../../proto/utilspb/pagination_pb.js')
const proto = {};
proto.reorgpb = require('./split_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.reorgpb.SplitServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.reorgpb.SplitServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reorgpb.ListSplitRequest,
 *   !proto.reorgpb.ListSplitResponse>}
 */
const methodDescriptor_SplitService_ListSplit = new grpc.web.MethodDescriptor(
  '/reorgpb.SplitService/ListSplit',
  grpc.web.MethodType.UNARY,
  proto.reorgpb.ListSplitRequest,
  proto.reorgpb.ListSplitResponse,
  /**
   * @param {!proto.reorgpb.ListSplitRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reorgpb.ListSplitResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.reorgpb.ListSplitRequest,
 *   !proto.reorgpb.ListSplitResponse>}
 */
const methodInfo_SplitService_ListSplit = new grpc.web.AbstractClientBase.MethodInfo(
  proto.reorgpb.ListSplitResponse,
  /**
   * @param {!proto.reorgpb.ListSplitRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reorgpb.ListSplitResponse.deserializeBinary
);


/**
 * @param {!proto.reorgpb.ListSplitRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.reorgpb.ListSplitResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reorgpb.ListSplitResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reorgpb.SplitServiceClient.prototype.listSplit =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reorgpb.SplitService/ListSplit',
      request,
      metadata || {},
      methodDescriptor_SplitService_ListSplit,
      callback);
};


/**
 * @param {!proto.reorgpb.ListSplitRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reorgpb.ListSplitResponse>}
 *     Promise that resolves to the response
 */
proto.reorgpb.SplitServicePromiseClient.prototype.listSplit =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reorgpb.SplitService/ListSplit',
      request,
      metadata || {},
      methodDescriptor_SplitService_ListSplit);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reorgpb.Split,
 *   !proto.reorgpb.CreateSplitResponse>}
 */
const methodDescriptor_SplitService_CreateSplit = new grpc.web.MethodDescriptor(
  '/reorgpb.SplitService/CreateSplit',
  grpc.web.MethodType.UNARY,
  proto.reorgpb.Split,
  proto.reorgpb.CreateSplitResponse,
  /**
   * @param {!proto.reorgpb.Split} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reorgpb.CreateSplitResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.reorgpb.Split,
 *   !proto.reorgpb.CreateSplitResponse>}
 */
const methodInfo_SplitService_CreateSplit = new grpc.web.AbstractClientBase.MethodInfo(
  proto.reorgpb.CreateSplitResponse,
  /**
   * @param {!proto.reorgpb.Split} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reorgpb.CreateSplitResponse.deserializeBinary
);


/**
 * @param {!proto.reorgpb.Split} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.reorgpb.CreateSplitResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reorgpb.CreateSplitResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reorgpb.SplitServiceClient.prototype.createSplit =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reorgpb.SplitService/CreateSplit',
      request,
      metadata || {},
      methodDescriptor_SplitService_CreateSplit,
      callback);
};


/**
 * @param {!proto.reorgpb.Split} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reorgpb.CreateSplitResponse>}
 *     Promise that resolves to the response
 */
proto.reorgpb.SplitServicePromiseClient.prototype.createSplit =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reorgpb.SplitService/CreateSplit',
      request,
      metadata || {},
      methodDescriptor_SplitService_CreateSplit);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reorgpb.Split,
 *   !proto.reorgpb.UpdateSplitResponse>}
 */
const methodDescriptor_SplitService_UpdateSplit = new grpc.web.MethodDescriptor(
  '/reorgpb.SplitService/UpdateSplit',
  grpc.web.MethodType.UNARY,
  proto.reorgpb.Split,
  proto.reorgpb.UpdateSplitResponse,
  /**
   * @param {!proto.reorgpb.Split} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reorgpb.UpdateSplitResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.reorgpb.Split,
 *   !proto.reorgpb.UpdateSplitResponse>}
 */
const methodInfo_SplitService_UpdateSplit = new grpc.web.AbstractClientBase.MethodInfo(
  proto.reorgpb.UpdateSplitResponse,
  /**
   * @param {!proto.reorgpb.Split} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reorgpb.UpdateSplitResponse.deserializeBinary
);


/**
 * @param {!proto.reorgpb.Split} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.reorgpb.UpdateSplitResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reorgpb.UpdateSplitResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reorgpb.SplitServiceClient.prototype.updateSplit =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reorgpb.SplitService/UpdateSplit',
      request,
      metadata || {},
      methodDescriptor_SplitService_UpdateSplit,
      callback);
};


/**
 * @param {!proto.reorgpb.Split} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reorgpb.UpdateSplitResponse>}
 *     Promise that resolves to the response
 */
proto.reorgpb.SplitServicePromiseClient.prototype.updateSplit =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reorgpb.SplitService/UpdateSplit',
      request,
      metadata || {},
      methodDescriptor_SplitService_UpdateSplit);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reorgpb.Split,
 *   !proto.reorgpb.DeleteSplitResponse>}
 */
const methodDescriptor_SplitService_DeleteSplit = new grpc.web.MethodDescriptor(
  '/reorgpb.SplitService/DeleteSplit',
  grpc.web.MethodType.UNARY,
  proto.reorgpb.Split,
  proto.reorgpb.DeleteSplitResponse,
  /**
   * @param {!proto.reorgpb.Split} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reorgpb.DeleteSplitResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.reorgpb.Split,
 *   !proto.reorgpb.DeleteSplitResponse>}
 */
const methodInfo_SplitService_DeleteSplit = new grpc.web.AbstractClientBase.MethodInfo(
  proto.reorgpb.DeleteSplitResponse,
  /**
   * @param {!proto.reorgpb.Split} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reorgpb.DeleteSplitResponse.deserializeBinary
);


/**
 * @param {!proto.reorgpb.Split} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.reorgpb.DeleteSplitResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reorgpb.DeleteSplitResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reorgpb.SplitServiceClient.prototype.deleteSplit =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reorgpb.SplitService/DeleteSplit',
      request,
      metadata || {},
      methodDescriptor_SplitService_DeleteSplit,
      callback);
};


/**
 * @param {!proto.reorgpb.Split} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reorgpb.DeleteSplitResponse>}
 *     Promise that resolves to the response
 */
proto.reorgpb.SplitServicePromiseClient.prototype.deleteSplit =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reorgpb.SplitService/DeleteSplit',
      request,
      metadata || {},
      methodDescriptor_SplitService_DeleteSplit);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reorgpb.ListSplitRequest,
 *   !proto.reorgpb.ListSplitResponse>}
 */
const methodDescriptor_SplitService_MovePageSplit = new grpc.web.MethodDescriptor(
  '/reorgpb.SplitService/MovePageSplit',
  grpc.web.MethodType.UNARY,
  proto.reorgpb.ListSplitRequest,
  proto.reorgpb.ListSplitResponse,
  /**
   * @param {!proto.reorgpb.ListSplitRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reorgpb.ListSplitResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.reorgpb.ListSplitRequest,
 *   !proto.reorgpb.ListSplitResponse>}
 */
const methodInfo_SplitService_MovePageSplit = new grpc.web.AbstractClientBase.MethodInfo(
  proto.reorgpb.ListSplitResponse,
  /**
   * @param {!proto.reorgpb.ListSplitRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reorgpb.ListSplitResponse.deserializeBinary
);


/**
 * @param {!proto.reorgpb.ListSplitRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.reorgpb.ListSplitResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reorgpb.ListSplitResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reorgpb.SplitServiceClient.prototype.movePageSplit =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reorgpb.SplitService/MovePageSplit',
      request,
      metadata || {},
      methodDescriptor_SplitService_MovePageSplit,
      callback);
};


/**
 * @param {!proto.reorgpb.ListSplitRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reorgpb.ListSplitResponse>}
 *     Promise that resolves to the response
 */
proto.reorgpb.SplitServicePromiseClient.prototype.movePageSplit =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reorgpb.SplitService/MovePageSplit',
      request,
      metadata || {},
      methodDescriptor_SplitService_MovePageSplit);
};


module.exports = proto.reorgpb;

